import BASE_URL from "../config/apiConfig";

export const TenantService = {
  // Function to get the auth token from session storage
  getAuthToken() {
    return sessionStorage.getItem("jwt");
  },

  async fetchAllTenants() {
    const token = this.getAuthToken();
    try {
      const response = await fetch(`${BASE_URL}Tenant`, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          ...(token && { Authorization: `Bearer ${token}` }),
        },
      });

      if (!response.ok) {
        throw new Error("Failed to fetch all tenants");
      }

      return await response.json();
    } catch (error) {
      console.error("Error fetching tenants:", error);
      throw error;
    }
  },

  async fetchTenantsByProperty(propertyId: any) {
    const token = this.getAuthToken();
    try {
      const response = await fetch(`${BASE_URL}Tenant/${propertyId}`, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          ...(token && { Authorization: `Bearer ${token}` }),
        },
      });

      if (!response.ok) {
        throw new Error("Failed to fetch tenants");
      }

      return await response.json();
    } catch (error) {
      console.error("Error fetching tenants:", error);
      throw error;
    }
  },

  // Add or update property data (POST)
  async postTenant(propertyData: any) {
    const token = this.getAuthToken();
    try {
      const response = await fetch(`${BASE_URL}Tenant/AddTenant`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          ...(token && { Authorization: `Bearer ${token}` }),
        },
        body: JSON.stringify(propertyData),
      });

      if (!response.ok) {
        throw new Error("Failed to create/update tenant");
      }

      return await response.json();
    } catch (error) {
      console.error("Error posting tenant:", error);
      throw error;
    }
  },

  async updateTenant(tenantData: any) {
    const token = this.getAuthToken();
    try {
      const response = await fetch(`${BASE_URL}Tenant/${tenantData.id}`, {
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
          ...(token && { Authorization: `Bearer ${token}` }),
        },
        body: JSON.stringify(tenantData),
      });

      if (!response.ok) {
        const errorText = await response.text();
        throw new Error(`Failed to update tenant: ${errorText}`);
      }

      return await response.json();
    } catch (error) {
      console.error("Error updating tenant:", error);
      throw error;
    }
  },
  async deleteTenant(tenantId: number) {
    const token = this.getAuthToken();
    try {
      const response = await fetch(`${BASE_URL}Tenant/${tenantId}`, {
        method: "DELETE",
        headers: {
          "Content-Type": "application/json",
          ...(token && { Authorization: `Bearer ${token}` }),
        },
      });

      if (!response.ok) {
        const errorText = await response.text();
        throw new Error(`Failed to delete tenant: ${errorText}`);
      }

      return await response.json();
    } catch (error) {
      console.error("Error deleting property:", error);
      throw error;
    }
  },
};
